module.exports = __webpack_public_path__ + "img/CORVETTE.a8f62b8.jpg";